export var contentOutlines = {
    shadow: 'shadow',
    border: 'border',
    none: 'none',
};
export var skins = {
    neutral: 'neutral',
    gradient: 'gradient',
    custom: 'custom',
};
export var dataHooks = {
    contentArea: 'preview-widget-content-area',
};
//# sourceMappingURL=constants.js.map